import utils from '../utils';
import { METHODS } from '../constants';

const customer = () => ({
  getHoldingsUrl: (investmentId: string) =>
    `${process.env.HOST}/api/customer/current-holdings?investmentId=${investmentId}&showAnnualizedReturn=false`,
  getHoldingsUrlCIB: (investmentId: string) =>
    `${process.env.HOST}/api/customer/current-holdings-cib?investmentId=${investmentId}&showAnnualizedReturn=false`,
  getHoldingsUrlNew: (investmentId: string, showAnnualized?: boolean) =>
    utils.fetch(
      `${process.env.HOST}/api/customer/current-holdings?investmentId=${investmentId}&showAnnualizedReturn=${showAnnualized}`
    ),
  getHoldingsUrlNewCIB: (investmentId: string, showAnnualized?: boolean) =>
    utils.fetch(
      `${process.env.HOST}/api/customer/current-holdings-cib?investmentId=${investmentId}&showAnnualizedReturn=${showAnnualized}`
    ),
  getProfile: () => utils.fetch(`${process.env.HOST}/api/customer/profile-info`),
  getMyrtlePopup: (page: string) => utils.fetch(`${process.env.HOST}/api/customer/myrtlePopup?page=${page}`),
  getNotifications: () => utils.fetch(`${process.env.HOST}/api/customer/notifications`),
  getDetails: () => utils.fetch(`${process.env.HOST}/api/customer/other-details`),
  getRiskProfile: () => `${process.env.HOST}/api/customer/risk-profile-details`,
  emailStatement: (investmentId: string, fromDate: string, toDate: string, reportType: string) =>
    utils.fetch(
      `${process.env.HOST}/api/customer/statements/email-report?investmentId=${investmentId}&fromDate=${fromDate}&toDate=${toDate}&reportType=${reportType}`
    ),
  downloadStatement: (investmentId: string, fromDate: string, toDate: string, reportType: string, fileName: string) =>
    utils.downloadFetcher(
      `${process.env.HOST}/api/customer/statements/download-pdf?investmentId=${investmentId}&fromDate=${fromDate}&toDate=${toDate}&reportType=${reportType}`,
      fileName
    ),
  getInsightAllocation: (investmentId: string) =>
    utils.fetch(`${process.env.HOST}/api/customer/insight-allocation?investmentId=${investmentId}`),
  getInsights: (investmentId: string) =>
    utils.fetch(`${process.env.HOST}/api/customer/insight?investmentId=${investmentId}`),
  getPastRedeemSwitchTrans: (investmentId: string) =>
    `${process.env.HOST}/api/customer/past-mf-redeem-switch-transactions?investmentId=${investmentId}`,
  getUserGuideDetails: (page: string) => utils.fetch(`${process.env.HOST}/api/customer/userguide?page=${page}`),
  get2FADetails: (fundId: string, folioNumber: string, transType: string, orderId: string) =>
    utils.fetch(
      `${process.env.HOST}/api/customer/two-fa-auth?fundId=${fundId}&folioNumber=${folioNumber}&transType=${transType}&orderId=${orderId}`
    ),
  updateUserGuideDetails: (page: string) =>
    utils.fetch(`${process.env.HOST}/api/customer/userguide?page=${page}`, { method: METHODS.POST }),
  getMaximusAuthToken: () => utils.fetch(`${process.env.HOST}/api/registration/get-esb-maximus-auth`),
  logEventCount: (eventType: string) =>
    utils.fetch(`${process.env.HOST}/api/customer/logClickEvent?eventType=${eventType}`),
  getPanByInvestmentId: (investmentId: string) =>
    utils.fetch(`${process.env.HOST}/api/customer/getPanByInvestmentId?investmentId=${investmentId}`),
});

export default customer;
